module.exports = __webpack_public_path__ + "img/linkedin-icon.0940ab9f.svg";